import React, {Component} from 'react'
import ImmutablePropTypes from 'react-immutable-proptypes'

import FlightDetail from './FlightDetail'
// FIXME consider adding logic to differentiate between Accomodation service and Flight service
// FIXME this is also being used in BookingConfirmationResponse to show flight details there.
class OfferDetails extends Component {

  render(){
    const {offer, airportByIata, defaultCollapseState=true} = this.props
    return <div>
    {offer.get('serviceDetail').map((sd = Map()) =>
        <div className="result-group" key={sd.get('uri')}><FlightDetail serviceDetail={sd} airportByIata={airportByIata} defaultCollapseState={defaultCollapseState}/></div>
      )
    }</div>
  }
}

OfferDetails.propTypes = {
    // List<OfferAsMap>
    offer : ImmutablePropTypes.map.isRequired,
    // Map<IataCode,AirportAsMap>
    airportByIata : ImmutablePropTypes.map.isRequired
}

export default OfferDetails



// WEBPACK FOOTER //
// ./src/ndc/booking/OfferDetails.js